import React from 'react';
import { Users } from 'lucide-react';
import { Button, Card, ParticipantCard } from 'shared-portal-components-v2';

import type { ParticipantCardModel } from '@/types/SixDetail.types';
import { MIN_LEN } from '@/constants';
import SixDetailSectionHeader from '@/components/molecules/SixDetailSectionHeader/SixDetailSectionHeader';

export interface SixDetailParticipantsPanelProps {
  membersCount: number;
  participantCards: ParticipantCardModel[];
  onManageAccessClick?: () => void;
  className?: string;
}

function SixDetailParticipantsPanel({
  membersCount,
  participantCards,
  onManageAccessClick,
  className,
}: SixDetailParticipantsPanelProps): React.ReactElement {
  const countLabel = `${membersCount} members`;

  function handleManageAccessClick(): void {
    if (typeof onManageAccessClick === 'function') onManageAccessClick();
  }

  return (
    <div className={className}>
      <div className="space-y-4 sm:space-y-6">
        <SixDetailSectionHeader
          title="SIX Members"
          countLabel={countLabel}
          action={onManageAccessClick === undefined ? undefined : (
            <Button
              variant="tertiary"
              className="w-full sm:w-auto border-border border rounded-md"
              onClick={handleManageAccessClick}
            >
              <Users className="h-4 w-4 mr-2" />
              Manage Access
            </Button>
          )}
        />

        <div className="grid gap-3 sm:gap-4">
          {participantCards.length === MIN_LEN ? (
            <Card className="p-6">
              <div className="text-sm text-muted-foreground">No participants loaded.</div>
            </Card>
          ) : (
            participantCards.map((participantCard) => (
              <ParticipantCard key={participantCard.id} participant={participantCard} />
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default SixDetailParticipantsPanel;
